import { Box, Typography } from "@mui/material";
import { useUtilityContent } from "./UtilityContent";

export const PackageCard = () => {
  const {
    bill: { logoUrl, name },
  } = useUtilityContent();

  return (
    <Box sx={{ borderRadius: "20px", alignItems: "center", padding: "20px 25px", backgroundColor: "primary.main", display: "flex", gap: "25px" }}>
      <Typography
        sx={{
          backgroundColor: "secondary.main",
          color: "secondary.contrastText",
          borderRadius: "12px",
          width: "110px",
          height: "60px",
          fontSize: "28px",
          fontWeight: 700,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {name?.match(/\b\w/g)?.join("").substring(0, 2)}
        <Box component={"img"} src={logoUrl} sx={{ width: "100%", height: "100%", position: "absolute", left: 0, top: 0 }} />
      </Typography>
      <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: "24px" }}>{name}</Typography>
    </Box>
  );
};
